import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Select2Multiple from 'v-select2-multiple-component';
import axios from "axios";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import CONFIG from "@/assets/js/config.custom.js";
import store from '../../../store';

export default {
    name: 'scoreSettingList',
    components: {
        MainLayout,
        Loading,
        Select2Multiple,
        AdvancedLaravelVuePaginate,
    },

    data() {
        return {
            noDataMsg: CONFIG.NO_DATA_FOUND,
            scoreSettingLists: {},
            isFilterOpen: false,
            isLoading: true,
            searchStatus: false,
            acdYearList: [],
            gradeList: [],
            searchData: {
                acd_year_id: '',
                grade_id: '',
            },
            currentPage: 1,
        };
    },

    methods: {
        reset() {
            this.searchData = {
                acd_year_id: '',
                grade_id: '',
            };
            this.isLoading = true;
            this.fetchScoreLists();
        },

        async getParentAcdYearList() {
            try {
                const response = await axios.get('score-setting/parent-acd-year');
                if (response.data) {
                    const rawData = response.data.data;
                    this.acdYearList = rawData.map(item => ({
                        id: item.id,
                        text: item.period_name
                    }));
                }
            } catch (error) {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                console.error("Error fetching academic year list:", error);
            } finally {
                this.isLoading = false;
            }
        },


        getGradeList(yearId) {
            axios.get('getGradeNameByAcademicYear?id=' + yearId, {
                params: {
                    campus_id: store.state.user.campus_id
                }
            }).then(res => {
                let $defaultSelectOption = [{
                    "id": 0,
                    "text": "All"
                }];
                this.gradeList = $defaultSelectOption.concat(res.data);
                this.isLoading = false;
            }).catch((error) => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                this.isLoading = false;
            });
        },

        fetchScoreLists(page = 1) {
            this.searchStatus = false;
            this.isLoading = true;
            axios.get("/score-setting?page=" + page)
                .then((response) => {
                    if (response.data) {
                        this.scoreSettingLists = response.data;
                        this.currentPage = response.data.current_page
                        this.isLoading = false;
                    }
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                })
        },

        confirmDelete(id) {
            if (window.confirm("Are you sure you want to delete?")) {
                this.deleteScoreSetting(id);
            }
        },

        deleteScoreSetting(id) {
            this.isLoading = true;
            axios.delete("/score-setting/" + id)
                .then(response => {
                    if (response.data.success == true) {
                        let targetPage = this.currentPage;
                        if (this.scoreSettingLists?.data?.length === 1 && this.currentPage > 1) {
                            targetPage = this.currentPage - 1;
                        }
                        if (this.searchStatus) {
                            this.search(targetPage);
                        } else {
                            this.fetchScoreLists(targetPage);
                        }
                        this.$notification.success(response.data.message, {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                })
                .catch(error => {
                    if (!error.response) {
                        console.log("Score setting Delete Error", error);
                        return;
                    }
                    const status = error.response.status;
                    if (status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    } else if (status == 422) {
                        this.$notification.error(error.response.data.message, {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.fetchScoreLists();
                    } else {
                        this.$notification.error("Something went wrong. Please try again.", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                }).finally(() => {
                    this.isLoading = false;
                });
        },

        search(page = 1) {
            this.searchStatus = true;
            this.isLoading = true;

            axios.get("/score-setting", {
                params: {
                    page: page,
                    ...this.searchData
                }
            })
                .then(response => {
                    this.scoreSettingLists = response.data;
                    this.currentPage = response.data.current_page;
                })
                .catch(error => {
                    if (error.response?.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        showCreate() {
            this.$router.push({
                name: "scoreSettingCreate"
            });
        },

        showImport() {
            this.$router.push({
                name: "scoreSettingImport"
            });
        },

        showDetail(id) {
            this.$router.push({
                name: "scoreSettingDetail",
                params: {
                    id: id
                }
            });
        },

        showEdit(id) {
            this.$router.push({
                name: "scoreSettingEdit",
                params: {
                    id: id
                }
            });
        },
    },

    watch: {
        'searchData.acd_year_id'(acdYearId) {
            this.searchData.grade_id = '';
            this.gradeList = [];
            if (acdYearId) {
                this.getGradeList(acdYearId);
            } else {
                this.gradeList = [];
            }
        }
    },

    mounted() {
        this.isLoading = true;
        this.getParentAcdYearList();
        this.fetchScoreLists();
    }
};
